// extracted by mini-css-extract-plugin
module.exports = {"row":"page-module--row--1v5gP","column":"page-module--column--1D9be"};